import {NavigationPageEnum, NavigationPageEnumHumanReadable} from '../../navigations.enums';
import {IUserAccessFeature} from '../user-access-features';
import {SettingsReferenceEnum} from '../../../../settings-new/models';

//#region INTERFACE IFeatureStaffAccess
export interface IFeatureStaffAccess extends IUserAccessFeature, Object {
}

//#endregion

//#region CONST _FEATURE_STAFF_ACCESS_DEFAULT
export const _FEATURE_STAFF_ACCESS_DEFAULT: Readonly<IFeatureStaffAccess & Object> = {
  displayText: NavigationPageEnumHumanReadable.UserAccess,
  feature: NavigationPageEnum.UserAccess,
  ref: SettingsReferenceEnum.undefined,
  standalone: false,
};
//#endregion